module.exports = "https://trybtryb-legacy.web.app/img/customise.cffe749d.webp";